export default {"src":"/_next/static/media/model-robustness-evaluation.c131a29b.svg","height":512,"width":576,"blurWidth":0,"blurHeight":0};